var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { margin: "-24px -24px 0px" } },
    [
      _c(
        "page-header",
        {
          attrs: {
            breadcrumb: _vm.breadcrumb,
            title: _vm.title,
            logo: _vm.logo,
            avatar: _vm.avatar
          }
        },
        [
          _vm._t("action", null, { slot: "action" }),
          _vm._v(" "),
          _vm._t("headerContent", null, { slot: "content" }),
          _vm._v(" "),
          !this.$slots.headerContent && _vm.desc
            ? _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _c(
                  "p",
                  {
                    staticStyle: {
                      "font-size": "14px",
                      "line-height": "1.5",
                      color: "rgba(0,0,0,.65)"
                    }
                  },
                  [_vm._v(_vm._s(_vm.desc))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "link" },
                  [
                    _vm._l(_vm.linkList, function(link, index) {
                      return [
                        _c(
                          "a",
                          { key: index, attrs: { href: link.href } },
                          [
                            _c("a-icon", { attrs: { type: link.icon } }),
                            _vm._v(_vm._s(link.title))
                          ],
                          1
                        )
                      ]
                    })
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("extra", null, { slot: "extra" })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "page", class: ["page-content", _vm.layout] },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72f5ea18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72f5ea18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/PageLayout.vue
// module id = null
// module chunks = 